import { Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-bib-record-dialog',
  templateUrl: './bib-record-dialog.component.html',
  styleUrls: ['./bib-record-dialog.component.scss'],
})
export class BibRecordDialog {
  reply1: any = 'yes';
  reply2: any = 'no';

  constructor(
    public dialogRef: MatDialogRef<BibRecordDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  saveData() {
    this.dialogRef.close('yes');
  }
}
